import React from 'react';
import { CardContent, Stack, Alert, AlertTitle } from '@mui/material';
import IdentificationSection from './sections/IdentificationSection';
import LocationSection from './sections/LocationSection';
import StatusDatesSection from './sections/StatusDatesSection';
import NotesSection from './sections/NotesSection';

/**
 * AssetCreateForm - Main form container for asset creation
 * Organizes all sections in a logical flow
 */
export const AssetCreateForm: React.FC = () => {
  return (
    <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
      <Stack spacing={2.5}>
        <IdentificationSection />
        <LocationSection />
        <StatusDatesSection />
        <NotesSection />

        {/* No upload control until the asset has been saved once and has an id */}
        <Alert
          severity="info"
          sx={{
            backgroundColor: '#f0f9ff',
            border: '1px solid #bae6fd',
            borderRadius: 1.5,
            '& .MuiAlert-icon': {
              color: '#0284c7'
            }
          }}
        >
          <AlertTitle sx={{ fontWeight: 600, color: '#0f172a' }}>
            Documents
          </AlertTitle>
          Documents can be added after saving this asset.
        </Alert>
      </Stack>
    </CardContent>
  );
};

export default AssetCreateForm;
